import { Reveal } from "./motion";
import { IMAGES, TRAINING, DOCTOR } from "@/data";
import { GraduationCap, Award, ShieldCheck } from "lucide-react";

const badges = [
  { icon: GraduationCap, label: "M.Ch. Gynecologic Oncology, AIMS Kochi" },
  { icon: ShieldCheck, label: "ESGO · FMAS · IAPC Certified" },
  { icon: Award, label: "AIR 80 · NEET-SS Super Speciality" },
];

export const About = () => (
  <section id="about" className="py-24 sm:py-36 scroll-mt-24" data-testid="about">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="overline text-[#B9735A] mb-5">About the Doctor</p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl text-[#1A1C1A] leading-tight tracking-tight">
            A dedicated life in <span className="italic text-[#B9735A]">women's cancer care</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="relative mt-8 rounded-3xl overflow-hidden border border-black/5 shadow-xl shadow-black/5">
            <img src={IMAGES.hospital} alt="SPARSH Hospital" className="w-full h-72 object-cover" />
            <div className="absolute bottom-0 inset-x-0 bg-[#1A1C1A]/70 backdrop-blur-sm px-5 py-4">
              <p className="text-[#FDFBF7] text-sm font-medium">{DOCTOR.hospital}</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal delay={0.15}>
          <div className="space-y-5 text-[#4A4D4A] text-base sm:text-lg leading-relaxed">
            <p>
              <span className="text-[#1A1C1A] font-medium">{DOCTOR.name}</span> is a Consultant
              Gynecologic Oncologist at SPARSH Hospital, Sarjapur Road, Bengaluru. She completed her
              M.Ch. in Gynecologic Oncology from the Amrita Institute of Medical Sciences (AIMS), Kochi —
              one of India's premier tertiary cancer centres — and also holds an MS and DNB in
              Obstetrics &amp; Gynaecology.
            </p>
            <p>
              She is a Fellow of Minimal Access Surgery (FMAS) and certified by the European Society of
              Gynaecological Oncology (ESGO) and the Indian Association of Palliative Care (IAPC). To
              deepen her expertise, she completed clinical observerships at Tata Memorial Hospital, Mumbai
              and Tata Medical Center, Kolkata.
            </p>
            <p>
              With over 12 years of clinical experience and more than 4 years of specialized training in
              gynecologic oncology, she works closely with medical and radiation oncologists,
              radiologists, pathologists, genetic specialists and palliative care teams to achieve the
              best possible outcomes for every patient.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {badges.map((b) => (
              <div key={b.label} className="rounded-2xl border border-black/5 bg-white p-5 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300">
                <b.icon className="text-[#B9735A]" size={22} />
                <p className="mt-3 text-sm text-[#1A1C1A] leading-snug">{b.label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-10">
            <p className="overline text-[#6B7A6A] mb-4">Training & Fellowships</p>
            <div className="space-y-3">
              {TRAINING.map((t) => (
                <div key={t.place} className="flex gap-4 border-l-2 border-[#B9735A]/40 pl-5 py-1">
                  <div>
                    <p className="text-[#1A1C1A] font-medium">{t.place}</p>
                    <p className="text-sm text-[#4A4D4A]">{t.detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
